import request from '../request/request';
import {handleRes} from '../utils/utils';


interface HandleResInterface {
    success: any,
    fail: any,
}


const getRole = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.GETRole(params);
        const result = handleRes(res, {
            failMes: res.msg
        });
        resolve(result);
    });
};
const getRoleList = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.GETRoleList(params);
        const result = handleRes(res, {
            failMes: res.msg
        });
        resolve(result);
    });
};
const deleteRoleDeleteRole = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.DELETERoleDeleteRole(params);
        const result = handleRes(res, {
            failMes: res.msg
        });
        resolve(result);
    });
};
const postRoleAddRole = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.POSTRoleAddRole(params);
        const result = handleRes(res, {
            failMes: res.msg
        });
        resolve(result);
    });
};
const postRoleUpdateRole = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.POSTRoleUpdateRole(params);
        const result = handleRes(res, {
            failMes: res.msg
        });
        resolve(result);
    });
};
// 获取权限列表
const getRoleAuthList = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.GETRoleRoleAuth(params);
        const result = handleRes(res, {
            failMes: res.msg
        });
        resolve(result);
    });
};
// 编辑角色全选
const postRoleAuthEdit = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.POSTRoleAuthEdit(params);
        const result = handleRes(res, {
            failMes: res.msg
        });
        resolve(result);
    });
};

export {
    getRole,
    getRoleList,
    deleteRoleDeleteRole,
    postRoleAddRole,
    postRoleUpdateRole,
    getRoleAuthList,
    postRoleAuthEdit
};
